import { Button, Typography } from 'antd';
import {
  ArrowRightOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  FormOutlined,
  HomeFilled,
} from '@ant-design/icons';
import { useIsMobile } from '@/context/IsMobileContext.tsx';
import { SURFACE } from '@/styles/surfaces.ts';

const { Title, Text } = Typography;

const JOURNEY = [
  {
    icon: <FormOutlined />,
    title: 'Property Survey',
    description: 'Tell us about your home and its structures',
  },
  {
    icon: <CalculatorOutlined />,
    title: 'Your Plan',
    description: 'Get a membership plan tailored to your property',
  },
  {
    icon: <CalendarOutlined />,
    title: 'Walkthrough',
    description: 'Schedule your in-home property walkthrough',
  },
  {
    icon: <CreditCardOutlined />,
    title: 'Membership',
    description: 'Activate your membership and relax',
  },
];

interface IWelcomeStepProps {
  firstName: string;
  onNext: () => void;
}

export const WelcomeStep = ({ firstName, onNext }: IWelcomeStepProps) => {
  const { isMobile } = useIsMobile();

  return (
    <div>
      <div className='onboarding-wizard-hero'>
        <div
          style={{
            width: isMobile ? 52 : 60,
            height: isMobile ? 52 : 60,
            borderRadius: 18,
            background: 'rgba(255, 255, 255, 0.18)',
            border: '1px solid rgba(255, 255, 255, 0.28)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
          }}
        >
          <HomeFilled style={{ fontSize: isMobile ? 24 : 28 }} />
        </div>
        <Title
          level={isMobile ? 4 : 3}
          style={{ color: '#fff', margin: 0, letterSpacing: '-0.02em' }}
        >
          Welcome{firstName ? `, ${firstName}` : ''}
        </Title>
        <Text
          style={{
            color: 'rgba(255, 255, 255, 0.86)',
            fontSize: isMobile ? 14 : 15.5,
            lineHeight: 1.6,
          }}
        >
          Let's get your home set up. It takes about two minutes.
        </Text>
      </div>

      <div style={{ padding: isMobile ? '22px 20px' : '28px 34px' }}>
        <Text
          style={{
            fontSize: 13,
            fontWeight: 600,
            display: 'block',
            marginBottom: 16,
            color: SURFACE.text.muted,
          }}
        >
          Here's your journey
        </Text>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? 4 : 2,
            marginBottom: isMobile ? 22 : 26,
          }}
        >
          {JOURNEY.map((item, index) => (
            <div
              key={item.title}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 14,
                padding: '10px 0',
                borderTop: index === 0 ? 'none' : `1px solid ${SURFACE.line.soft}`,
              }}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: 'rgba(91, 110, 225, 0.1)',
                  color: SURFACE.accent.solid,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 15,
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </div>
              <div style={{ minWidth: 0 }}>
                {/* The number is the position in the list, not a "Step N"
                    label bolted onto the name. */}
                <Text strong style={{ color: SURFACE.text.strong, fontSize: 14.5 }}>
                  {index + 1}. {item.title}
                </Text>
                <br />
                <Text style={{ fontSize: 13, color: SURFACE.text.muted, lineHeight: 1.55 }}>
                  {item.description}
                </Text>
              </div>
            </div>
          ))}
        </div>

        <Button
          type='primary'
          block
          icon={<ArrowRightOutlined />}
          iconPosition='end'
          onClick={onNext}
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};
